export default __webpack_public_path__ + "locales/sk/ResetApplicationDialog.json?hash=347b371ba085d3fe10084e08d9ca158b";